import * as React from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ButtonBase from '@mui/material/ButtonBase';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { NumericFormat } from 'react-number-format';

const UpDown = (props) => {

  const handleUp = (event) => {
    const value = parseInt(props.value) || 0;
    props.onValueChange(value + 1);    
  }

  const handleDown = (event) => {
    const value = parseInt(props.value) || 0;
    props.onValueChange(value - 1);    
  }

  return (
    <Stack direction="column" spacing={0} sx={{justifyContent: "flex-start", alignItems: "flex-start", paddingX: 0.5, visibility: props.isSelected ? 'visible' : 'hidden'}}>
      {/* <ButtonBase onClick={handleUp}><i className="fa-solid fa-caret-up" style={{fontSize: 14}}></i></ButtonBase> */}
      <ButtonBase onClick={handleUp}><ArrowDropUpIcon viewBox='5 5 14 14' sx={{width: '14px', height: '14px'}}/></ButtonBase>      
      {/* <ButtonBase onClick={handleDown}><i className="fa-solid fa-caret-down" style={{fontSize: 14}}></i></ButtonBase> */}
      <ButtonBase onClick={handleDown}><ArrowDropDownIcon viewBox='5 5 14 14' sx={{width: '14px', height: '14px'}}/></ButtonBase>
    </Stack>
  )
}

export const Bs4ViewNumberSummaryDetails = (props) => {  
  const decimals = parseInt(props.decimals) || 0;    
  const [isSelected, setIsSelected] = React.useState(false);
      
  const handleChange = (values, sourceInfo) => {
    if (sourceInfo.source !== 'event') return;
    props.onChange(values.floatValue);    
  }

  const thousandSeparator = decimals === 0 ? '' : ' ';
  const slotProps = decimals === 0 ? {
    input: {
      endAdornment: <InputAdornment position="end"><UpDown {...props} isSelected={isSelected}/></InputAdornment>,
      onPointerEnter:(e) => setIsSelected(true),
      onPointerLeave:(e) => setIsSelected(false),
    },
  } : {};

  // console.log('...???...readonly', props.readOnly, props);

  const materialUITextFieldProps = {  
    // fullWidth: true, 
    id: props.inputId,
    inputProps: { readOnly: props.readOnly},
    InputProps: { disableUnderline: props.readOnly},      
    slotProps: slotProps,
  };

  return (
    <NumericFormat
      value={props.value}
      thousandSeparator={thousandSeparator}
      decimalScale={decimals}
      decimalSeparator=','
      fixedDecimalScale
      onValueChange={handleChange}
      customInput={TextField}
      allowNegative
      {...materialUITextFieldProps}
    />
  )
}

export const Bs4ViewNumber = (props) => {
  const decimals = parseInt(props.decimals) || 0;  
  const [isSelected, setIsSelected] = React.useState(false);
      
  const handleChange = (values, sourceInfo) => {     
    if (sourceInfo.source !== 'event') return;
    if (values.value === '') props.onValueChange(values.value);
    else if (!isNaN(values.floatValue)) props.onValueChange(values.floatValue);
  }

  const thousandSeparator = decimals === 0 ? '' : ' ';
  const slotProps = !props.readOnly && decimals === 0 ? {
    endAdornment: <InputAdornment position="end"><UpDown {...props} isSelected={isSelected}/></InputAdornment>,      
  } : {};

  const materialUITextFieldProps = {
    // inputRef: this.refFocus,
    fullWidth: true, 
    id: props.id,
    label: props.label,
    InputLabelProps: props.hideLabel ? {sx:{display:'none'}} : null,
    error: props.error,
    helperText: props.helperText,
    slotProps: {
      inputLabel : props.hideLabel ? {sx:{display:'none'}} : null,
      htmlInput: {readOnly: props.readOnly},
      input: {
        disableUnderline: props.readOnly,
        ...slotProps,  
      },
    },
    onPointerEnter:(e) => setIsSelected(true),
    onPointerLeave:(e) => setIsSelected(false),
  };
  
  // console.log('...???...readonly', props.readOnly, props)

  return (
    <NumericFormat
      getInputRef={props.refFocus}
      value={props.value}
      thousandSeparator={thousandSeparator}
      decimalScale={decimals}
      decimalSeparator=','
      // fixedDecimalScale
      allowNegative
      onValueChange={handleChange}
      customInput={TextField}
      suffix={props.suffix || ''}
      {...materialUITextFieldProps}
    />
  )
}